import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTelegram = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-telegram';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.44 5.988c-.124.025-12.687 4.59-13.172 4.785-.716.289-1.143.604-1.087.8.069.241.435.411 1.652.771a47 47 0 0 1 1.366.428l.619.208.172.52c.095.286.363 1.114.596 1.84.6 1.866.674 2.007 1.006 1.907.086-.026.516-.33 1.028-.729.484-.377.959-.732 1.055-.788.22-.13.444-.134.685-.011.099.05.882.572 1.74 1.161 1.835 1.259 1.805 1.24 1.962 1.24.257 0 .405-.259.539-.94.047-.242.606-2.784 1.242-5.65C18.48 8.665 19 6.278 19 6.226c0-.185-.267-.299-.56-.238m-1.6 2.288c0 .066-.555.531-2.38 1.992-2.569 2.057-3.594 2.959-3.94 3.47-.126.185-.136.226-.167.66-.084 1.213-.228 1.796-.407 1.647-.092-.077-.216-.402-.385-1.014a43 43 0 0 0-.321-1.09c-.271-.862-.26-1.109.061-1.44.33-.339 1.062-.768 4.659-2.73 3.043-1.66 2.88-1.575 2.88-1.495"
    })
  }));
});
export default SvgTelegram;